import { Text, Center, Stack, Box } from "@chakra-ui/react"
import { useGlobalState } from "providers/globalState"
import SocialIcons from "components/header/SocialIcons"

export default function SocialMediaSection({
    text,
    className = "socialFooter",
    textAlign = "left",
    bgColor = "color3",
    textColor = "color6",
    iconColor,
    hoverColor,
    customLinks,
}) {
    const { site } = useGlobalState()

    const links = customLinks || {
        facebook: site.meeting?.facebookLink,
        twitter: site.meeting?.twitterLink,
    }

    return (
        <Center className={className} w="100%" bg={bgColor} py={{ base: "10px", lg: "10px" }}>
            <Stack direction={{ base: "column", lg: "row" }} gap={{ base: 0, lg: 12 }} alignItems="center">
                <Box textAlign={textAlign}>
                    <Text mt={0} color={textColor} fontSize={{ base: 20, lg: 24 }} pl="15px" pr="15px" fontWeight={600}>
                        {text}
                    </Text>
                </Box>
                <SocialIcons
                    size={{ base: "20px", lg: "24px" }}
                    padding={{ base: "10px", lg: "16px" }}
                    color={iconColor}
                    hoverColor={hoverColor}
                    links={links}
                />
            </Stack>
        </Center>
    )
}
